module.exports = __webpack_public_path__ + "img/symbol_unstyled.78722f52.svg";